import { useContext } from 'react';
import { NavigateOptions, useNavigate } from 'react-router';
import StepUrlsContext from './step-urls-context';
import { StepName } from '../services';

const useNavigateToStep = () => {
  const { stepUrlMap } = useContext(StepUrlsContext);
  const navigate = useNavigate();

  const navigateToStep = (stepName: StepName, options?: NavigateOptions) => {
    const stepUrl = stepUrlMap[stepName] || '';
    const url = `/steps/${stepUrl}`;
    navigate(url, options);
  };

  return navigateToStep;
};

export default useNavigateToStep;
